import React, { useEffect, useState } from "react";
import Request from "../../../utils/Request";
import Config from "../../../utils/config";
import { TabsDetailsWrapper, Heading } from "../../styledConstants";
import SuccessMessage from "../../SuccessMessage";
import ErrorMessage from "../../ErrorMessage";
import { Switch } from "@mui/material";
import ApiRequest from "utils/ApiRequest";
import { CashbackCard } from "./style";
import { toast } from "react-toastify";
import Tooltip from "@mui/material/Tooltip";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

export default function CashbackConfig() {
  const [cashbackEnabled, setCashbackEnabled] = useState(false);

  useEffect(() => {
    fetchCashbackStatus();
  }, []);

  const fetchCashbackStatus = () => {
    const successHandler = (res) => {
      if (res.code === "0000") {
        const value =String(res?.data?.cashbackEnabledValue).trim().toUpperCase() === "TRUE";
        setCashbackEnabled(value);
      } else {
        toast.error(res.message || "Failed to fetch cashback status");
      }
    };

    const errorHandler = () => {
    toast.error("Failed to fetch cashback status");    };

    const api = new Request("", successHandler, errorHandler, false);

    return api.get(
      `${Config.apis.admin.GET_CASHBACK_CONFIG}` // add this in config
    );
  };

 const updateCashbackStatus = (value) => {
  const payload = {
    cashbackEnabledUpdateValue: value ? "TRUE" : "FALSE", // ✅ FIXED KEY
  };

  const successHandler = (res) => {
    if (res.code === "0000") {
      toast.success("Cashback status updated successfully");
    } else {
      toast.error(res.message || "Something went wrong");
    }
  };

  const errorHandler = () => {
   toast.error("Failed to update cashback status");
  };

  const api = new Request(payload, successHandler, errorHandler, false);

  return api.post(
  `${Config.apis.admin.UPDATE_CASHBACK_CONFIG}`, payload );
};
  const handleToggle = (e) => {
    const value = e.target.checked;
    setCashbackEnabled(value);
    updateCashbackStatus(value);
  };

  return (
    <TabsDetailsWrapper>
      <Heading size="xxl" className="mb50 mt20">
        Cashback Configuration
      </Heading>


    <CashbackCard>
    <div className="row">
        <div>
          <div className="label">
      Block Cashback
    
      <Tooltip title="Changes will be reflected after 1 minute" arrow>
        <InfoOutlinedIcon className="infoIcon" />
      </Tooltip>
    </div>
      <div className="subtext">
        Enable/Disable all type of cashback with global switch
      </div>
    </div>

    <Switch
      checked={cashbackEnabled}
      onChange={handleToggle}
    />
  </div>
</CashbackCard>
    </TabsDetailsWrapper>
  );
}